import { Component, OnInit } from '@angular/core';
import { RouteComponent } from '@app/route/route.component';
import { HeaderService } from '@app/service/header/header.service';
import { QueryParamsService } from '@app/service/query-params/query-params.service';
import { ActivatedRoute, Router } from '@angular/router';
import { StateService } from 'src/app/service/state/state.service';
import { SelectorItem } from '@app/component/selector/selector.component';
import { TermsLinkService } from '@app/service/terms-link/terms-link.service';

@Component({
  selector: 'se-precheck',
  templateUrl: './se-precheck.component.html',
  styleUrls: ['../../page-shared.css', './se-precheck.component.scss'],
})
export class SePrecheckComponent extends RouteComponent implements OnInit {
  loading: boolean = true;
  navigationInProgress: boolean = false;
  showError: boolean = false;
  selectorItems: SelectorItem[] = null;

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected stateService: StateService,
    protected headerService: HeaderService,
    protected queryParamsService: QueryParamsService,
    public termsLinkService: TermsLinkService
  ) {
    super(router, route, stateService, headerService);
  }

  ngOnInit(): void {
    if (this.state.forceNavigation) {
      const route = this.stateService.getRouteFromState(this.state);
      this.router.navigate([route], { queryParamsHandling: 'preserve' });
    }
    this.loading = false;
  }

  async handleCtaClick(): Promise<void> {
    this.showError = true;
    this.navigationInProgress = true;

    try {
      this.navigate();
    } catch (err) {
      this.handleError(err);
    }

    this.navigationInProgress = false;
  }
}
